import { render, staticRenderFns } from "./animal-picker.vue?vue&type=template&id=1b23aa15&"
import script from "./animal-picker.vue?vue&type=script&lang=js&"
export * from "./animal-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports